export default __webpack_public_path__ + "assets/MyriadPro-Semibold.6b1ba7b1.svg";